import * as React from 'react';

import './Slider.css';
import { RailProps } from './Rail';

export type SliderProps = RailProps & {
    // images: IPictureRef[];
    nodes: React.ReactNode[];
    width: number;
    units?: 'px' | '%';
    toSlide?: (slide: React.ReactNode) => ISlide;
    delay?: number;
    current?: number;
    onChange?: (i: number) => void;

    // loop?: boolean;// = true
    // shuffle?: boolean;// = true
    // autoplay?: boolean;// = false
    // stopOnInteract?: boolean;// = false
    // opacity?: number;// = false
    // keyboardEvents?: boolean;// = false
    // slidesPerPage: (slider: Slider) => number;
    // x: (slider: Slider, slide: Element, index: number) => string;
    // y: (slider: Slider, slide: Element, index: number) => string;
};

export type SliderState = SliderProps & {
    current: number;
    index: number;
    previous: number;
    width: number;
    playing: boolean;

    go: (i: number) => void;
    goNext: () => void;
    goPrevious: () => void;
};

const initSliderState: SliderState = {
    nodes: [],
    current: 0,
    index: 0,
    previous: 0,
    width: 0,
    playing: false,

    go: (i: number) => (void 0) as never,
    goNext: () => (void 0) as never,
    goPrevious: () => (void 0) as never,

};
export const SliderContext = React.createContext<SliderState>(initSliderState);

export interface ISlide {
    element: React.ReactNode;
    width: number;
}

export class Slider extends React.Component<SliderProps, SliderState> {
    
    static Rail: any;
    static Control: any;
    static Consumer = SliderContext.Consumer;
    static defaultProps: Partial<SliderProps> = {
        delay: 0,
        current: 0,
        units: '%',
        toSlide: (node: React.ReactNode) => ({ element: node, width: 100 }),
        onChange: () => null as never,
        drag: true,
    };

    private interval: number;

    constructor(props: SliderProps) {
        super(props);
        this._handleKeydown = this._handleKeydown.bind(this);
        this.state = {
            ...initSliderState,
            ...props,
            go: this._Go.bind(this),
            goNext: this._Next.bind(this),
            goPrevious: this._Previous.bind(this),
            playing: !!this.props.delay && this.props.delay > 0 && this.props.nodes.length > 1
        };
    }

    componentDidMount() {
        window.addEventListener('keydown', this._handleKeydown);
        // create timeout 
        if (this.state.playing) {
            this.interval = setInterval(this._OnInterval.bind(this), this.props.delay)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this._handleKeydown);
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    componentDidUpdate(prevProps: SliderProps, prevState: SliderState) {
        if (this.state.current !== prevState.current && this.props.onChange) {
            this.props.onChange(this.state.current);
        }
    }

    public render() {
        return (
            <SliderContext.Provider value={this.state}>
                {this.props.children}
            </SliderContext.Provider>
        );
    }

    private _getIndex(current: number) {
        const count = this.props.nodes.length;
        const n = Math.floor(current / count);
        return (current + Math.abs(n) * count) % count;
    }

    private _OnInterval() {
        if (!this.state.playing) {
            clearInterval(this.interval);
            return;
        }
        this.setState(prev => ({
            current: prev.current + 1,
            previous: prev.current,
            index: this._getIndex(prev.current + 1)
        }));
    }
    private _handleKeydown(e: KeyboardEvent) {
        switch (e.keyCode) {
            case 37: // left
                this._Previous();
                break;
            case 38: // up
                break;
            case 39: // right
                this._Next();
                break;
            case 40: // down
                break;
            default:
                break;
        }
    }

    private _Go(i: number) {

        this.setState(prev => ({
            playing: false,
            current: i,
            previous: prev.current,
            index: this._getIndex(i)
        }));
    }

    private _Next() {
        this._Go(this.state.current + 1);
    }

    private _Previous() {
        this._Go(this.state.current - 1);
    }
}

export default Slider;


// WEBPACK FOOTER //
// ./src/Components/Slider/Slider.tsx